import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

export const Option = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const Radio = styled.div<{ $selected: boolean }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid ${({ $selected }) => ($selected ? "#008cff" : "#9ca3af")};
  position: relative;

  &::after {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #008cff;
    position: absolute;
    top: 2px;
    left: 2px;
    opacity: ${({ $selected }) => ($selected ? 1 : 0)};
  }
`;

export const Content = styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  `;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Title = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #59637a;
`;

export const InfoIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const TagImage = styled.img`
  width: 29px;
  height: 14px;
`;

export const SubTitle = styled.div`
  font-size: 11px;
  color: ${theme.greyText};
  font-weight: 400;
`;

